// TeamMenuGroup.vue
<template>
  <div id="category" class="item">
      <p
        class="name"
        @click="collapseCategory(teamKey)"
        :class="{ active: String(teamKey) === String(selectedTeam) }"
      >
        {{ $t('params.category') }}
        {{ team.category.max_age }}
      </p>
      <div class="submenu" v-show="isSelected">
        <MenuItem
          v-for="item in visibleMenuItems"
          :key="item.key"
          :label="item.label"
          :active="isActive(item)"
          :number="item.number"
          :route="item.routeName"
          @click="onItemClick(item)"
        />
      </div>
  </div>
</template>

<script>
import MenuItem from '@/components/domain/home/left-menu/MenuItem.vue'
import { teamMenuConfig } from '@/config/team-menu-config.js'

export default {
  name: 'TeamMenuGroup',
  components: { MenuItem },
  data () {
    return {
      toggle_selected_team: 0
    }
  },
  props: {
    team: {
      type: Object,
      required: true
    },
    teamKey: {
      type: [String, Number],
      required: true
    },
    event: {
      type: Object,
      required: true
    },
    activePage: {
      type: String,
      required: true,
      default: ''
    },
    selectedTeam: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    visibleMenuItems () {
      return teamMenuConfig
        .filter(cfg => cfg.showIf(this.team, this.event, this.user))
        .map(cfg => {
          return {
            key: cfg.key,
            label: cfg.label,
            routeName: cfg.routeName,
            number: cfg.showNumber ? cfg.numberPath(this.team) : ''
          }
        })
    },
    isSelected () {
      return this.teamKey === this.selectedTeam
    }
  },
  methods: {
    collapseCategory (teamKey) {
      if (this.toggle_selected_team === 1) {
        this.$emit('collapse', false)
        this.toggle_selected_team = 0
        return
      }
      this.toggle_selected_team = 1
      this.$emit('collapse', teamKey)
    },
    onItemClick (item) {
      this.$emit('changeTeam', this.team.id)
      this.$emit('redirect', {
        routeName: item.routeName,
        teamId: this.team.id,
        key: item.key
      })
    },
    isActive (item) {
      let selectedTeamRoute = this.$route.params && this.$route.params.id
      selectedTeamRoute = selectedTeamRoute || this.$route.params.teamId
      selectedTeamRoute = selectedTeamRoute || this.$route.params.team_id
      return String(selectedTeamRoute) === String(this.teamKey) &&
        this.activePage === item.routeName
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/_left_menu.scss">
/* Add any component-specific overrides here */
</style>
